const registerHeaderComponent = () => {
  if (
    !window.Alpine ||
    window.__suHeaderComponentRegistered
  ) {
    return;
  }

  window.__suHeaderComponentRegistered = true;

  Alpine.data('Theme_Header', () => ({
    isStuck: false,
    isHidden: false,
    overlayHeaderWithSticky: null,
    overlayTextColor: null,

    init() {
      this.overlayHeaderWithSticky =
        this.$root.dataset.overlayHeaderWithSticky === 'true';

      if (this.overlayHeaderWithSticky) {
        this.setUpOverlayWithSticky();
      }
    },

    setUpOverlayWithSticky() {
      let positionerEl =
        document.getElementById('sticky-positioner');

      if (!positionerEl) {
        positionerEl = document.createElement('div');
        positionerEl.id = 'sticky-positioner';

        document.body.insertBefore(
          positionerEl,
          this.$root.closest('.shopify-section')
        );
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          this.isStuck = entry.intersectionRatio === 0;
        }
      );

      observer.observe(positionerEl);

      this.overlayTextColor =
        this.$root.dataset.overlayTextColorScheme;

      this.updateColorScheme(this.isStuck);

      this.$watch('isStuck', (value) => {
        this.updateColorScheme(value);
      });
    },

    updateColorScheme(isStuck) {
      if (isStuck) {
        this.$refs.header.setAttribute(
          'data-color-scheme',
          ''
        );

        this.$refs.header.classList.remove(
          'bg-transparent'
        );

        this.$refs.header.classList.add(
          'bg-scheme-background'
        );
      } else {
        this.$refs.header.setAttribute(
          'data-color-scheme',
          this.overlayTextColor
        );

        this.$refs.header.classList.remove(
          'bg-scheme-background'
        );

        this.$refs.header.classList.add(
          'bg-transparent'
        );
      }
    },
  }));
};

if (window.Alpine) {
  registerHeaderComponent();
} else {
  document.addEventListener(
    'alpine:init',
    registerHeaderComponent,
    {
      once: true,
    }
  );
}

/*
 * Gestione indipendente dello scorrimento.
 * Non dipende da Alpine e funziona anche
 * nell’anteprima dell’editor Shopify.
 */
const setupScrollHeader = (headerRoot) => {
  if (
    !headerRoot ||
    headerRoot.dataset.scrollHeaderReady === 'true'
  ) {
    return;
  }

  headerRoot.dataset.scrollHeaderReady = 'true';

  const sectionWrapper =
    headerRoot.closest('.shopify-section') ||
    headerRoot;

  let referenceScrollY = Math.max(
    window.scrollY,
    0
  );

  let ticking = false;

  /*
   * Quantità minima di movimento prima
   * di cambiare lo stato dell’header.
   */
  const threshold = 6;

  const setHidden = (hidden) => {
    headerRoot.classList.toggle(
      'su-header-hidden',
      hidden
    );

    sectionWrapper.classList.toggle(
      'su-header-hidden',
      hidden
    );
  };

  const update = () => {
    const currentScrollY = Math.max(
      window.scrollY,
      0
    );

    const difference =
      currentScrollY - referenceScrollY;

    const headerHeight =
      headerRoot.offsetHeight || 56;

    /*
     * All’inizio della pagina l’header
     * deve essere sempre visibile.
     */
    if (currentScrollY <= 4) {
      setHidden(false);
      referenceScrollY = currentScrollY;
      ticking = false;
      return;
    }

    /*
     * Accumula anche gli spostamenti lenti,
     * evitando reazioni alle piccole oscillazioni.
     */
    if (Math.abs(difference) >= threshold) {
      /*
       * Scorrimento verso il basso:
       * nasconde l’header.
       */
      if (
        difference > 0 &&
        currentScrollY > headerHeight
      ) {
        setHidden(true);
      }

      /*
       * Scorrimento verso l’alto:
       * mostra immediatamente l’header.
       */
      if (difference < 0) {
        setHidden(false);
      }

      referenceScrollY = currentScrollY;
    }

    ticking = false;
  };

  const onScroll = () => {
    if (ticking) return;

    ticking = true;

    window.requestAnimationFrame(update);
  };

  window.addEventListener(
    'scroll',
    onScroll,
    {
      passive: true,
    }
  );

  /*
   * Funzione usata da Shopify quando
   * la sezione viene ricaricata nell’editor.
   */
  headerRoot._suHeaderCleanup = () => {
    window.removeEventListener(
      'scroll',
      onScroll
    );

    setHidden(false);
  };
};

const initializeHeaders = (
  scope = document
) => {
  if (
    scope.matches?.('[data-theme-header]')
  ) {
    setupScrollHeader(scope);
  }

  scope
    .querySelectorAll?.('[data-theme-header]')
    .forEach(setupScrollHeader);
};

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    () => initializeHeaders(document),
    {
      once: true,
    }
  );
} else {
  initializeHeaders(document);
}

/*
 * Supporto all’editor del tema Shopify.
 */
document.addEventListener(
  'shopify:section:load',
  (event) => {
    initializeHeaders(event.target);
  }
);

document.addEventListener(
  'shopify:section:unload',
  (event) => {
    event.target
      .querySelectorAll?.(
        '[data-theme-header]'
      )
      .forEach((headerRoot) => {
        headerRoot._suHeaderCleanup?.();
      });
  }
);